import PropTypes from 'prop-types';
import classNames from 'classnames';
import './MediaLoading.scss';

const MediaLoading = ({ type = '', noBackground = false }) => (
  <div
    className={classNames('media-loading', {
      [`media-loading--${type}`]: type !== '',
      'media-loading--no-bg': noBackground,
    })}>
    <div className="media-loading__spinner"></div>
  </div>
);

MediaLoading.propTypes = {
  type: PropTypes.string,
};

export default MediaLoading;
